export default {
  noOffers: 'No Offers',
  offersAvailable: 'Offers Made',
  offersAwarded: 'Offers Awarded',
  partiallyAwarded: 'Partially Awarded',
};
